import { LangEn } from 'assets/locales/en';
import { Language } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';

// Same approach as missionTemplate/templateTexts.js: the list renders in the
// template form and in the mission detail, read straight from the locale files
// in the language Context.js sets for the whole admin.
const language = new Language();
language.loadLanguage(LangFr);
language.loadLanguage(LangEn);
language.setLanguage('fr');

/** A `toolProviders.*` text, with its `{name}` placeholders filled in. */
export const toolProviderText = (key, values = {}) =>
  Object.keys(values).reduce(
    (text, name) => text.split(`{${name}}`).join(String(values[name])),
    language.getValue(`toolProviders.${key}`, '')
  );
